import { Injectable } from '@angular/core';
import { APIAssetService, APIMetaService, APIQuestionService, APIQuoteScheduleService, APIUserService } from '@takectrl-multiapp/svcs-ctrl-api';
import {
  AssetType,
  IAddresses,
  IOccupations,
  IPostalCodeAreas,
  IProgressChecker,
  IQuestion,
  IQuoteRequest,
  IUser,
  IVheicleType,
  QuestionFilteringType,
  QuestionType,
  QuoteType,
  SharedConfig,
  UnderwritingAnswer,
} from '@takectrl-multiapp/svcs-share-config';
import { BUSNQuoteScheduleService } from './busn-quote-schedule.service';
import { firstValueFrom, take } from 'rxjs';
import { SharedConfigService } from 'libs/svcs-share-config/src/lib/services/shared-config.service';
type fromPage = 'question_comp' | 'quote_claims_history_check' | 'quote_summary_not_editable';
@Injectable({
  providedIn: 'root',
})
export class BUSNQuestionService {
  errorDescription: string;
  private setIsCompleteFlagRunning: Promise<void> | null = null;
  constructor(
    public apiQuestionService: APIQuestionService,
    public apiMetaService: APIMetaService,
    public apiUserService: APIUserService,
    public apiAssetService: APIAssetService,
    public apiQuoteScheduleService: APIQuoteScheduleService,
    public sharedConfig: SharedConfig,
    public sharedConfigService: SharedConfigService,
    public busnQuoteScheduleService: BUSNQuoteScheduleService
  ) {}

  async getUnderwritingQuestions(): Promise<Array<IQuestion>> {
    if (!SharedConfig.underwritingQuestionsAll) {
      const questions: Array<IQuestion> = (await this.getAllUnderwritingQuestions()).questions
          for (const question of questions) {
            if (question.type === QuestionType.boolean) {
              question.options = ['Yes', 'No'];
            }
      
            if (
              question.sub_heading &&
              (question.sub_heading.includes('What is the address where the vehicle is parked during the day? ') ||
                question.sub_heading.includes('What is the address where the vehicle is parked overnight? ') ||
                question.sub_heading.includes('What is the address where the motorcycle is parked overnight?') ||
                question.sub_heading.includes('What is the address where the caravan/trailer is parked overnight?') ||
                question.sub_heading.includes('What is the residential address of the building you want to insure?') ||
                question.sub_heading.includes('What is the residential address where the content you want to insure is held?') ||
                question.sub_heading.includes('Where do you live, your physical address? Note that this should not be a postal address.'))
            ) {
              question.type = QuestionType.address;
            }
      
            if (
              (question.sub_heading === 'What is the make of your vehicle?' ||
                question.sub_heading === 'What is the model of your vehicle?' ||
                question.sub_heading === 'In which year was it manufactured?' ||
                question.sub_heading === 'What is the make of your motorcycle?') &&
              (question.underwriting_answers[0].object_name === AssetType.Vehicles ||
                question.underwriting_answers[0].object_name === AssetType.Motorcycles)
            ) {
              question.type = QuestionType.vehicleSearch;
            }
      
            if (
              question.sub_heading === 'How many buildings claims did you have in the last...' ||
              question.sub_heading === 'How many motorcycle claims did the regular driver have in the last...' ||
              question.sub_heading === 'How many content-related claims did you have in the last...' ||
              question.sub_heading === 'How many caravan/trailer claims did you have in the last...'
            ) {
              question.type = QuestionType.multi;
            }
      
            if (question.sub_heading === 'What is your occupation?') {
              question.type = QuestionType.search;
            }
          }
      // const underwritingQuestions = await this.apiQuestionService.getUnderwritingQuestions();
      const filtered = questions.filter((x) => !x.underwriting_answers[0].hidden);
       return filtered;
    } else {
      return SharedConfig.underwritingQuestionsAll;
    }
  }

  async getAllUnderwritingQuestions() {
    return (await firstValueFrom(this.apiQuestionService.getUnderwritingQuestions())).results as IProgressChecker;
  }

  isAllQuestionsAndUnderwritingQuestionsAnswered(selectedAssetUnderwritingQuestions: IQuestion[]): boolean {
    for (const question of selectedAssetUnderwritingQuestions) {
      const x = this.isAllUnderwritingQuestionsAnswered(question);
      if (!x) {
        return false;
      }
    }
    return true;
  }

  isAllUnderwritingQuestionsAnswered(question: IQuestion): boolean {
    if (question && question.underwriting_answers) {
      for (const underwriting_answer of question.underwriting_answers) {
        if (
          underwriting_answer.object_answer === undefined ||
          underwriting_answer.object_answer === null ||
          (underwriting_answer.object_answer_error !== null && underwriting_answer.object_answer_error?.length > 0)
        ) {
          return false;
        }
      }
      return true;
    }
  }

  sanitizeQuestionsComparingToDBSource(user: IUser) {
    // const allUnderwritingQuestionsAsFetchedFromDB = this.getPersonalOrAssetSpecificQuestions(
    //   user,
    //   JSON.parse(JSON.stringify(SharedConfig.underwritingQuestionsAll)),
    //   SharedConfig.selectedAssetUnderwritingQuestions[0].underwriting_answers[0].object_name,
    //   QuestionFilteringType.hideHiddenQuestionsForSummary,
    //   true
    // );

    // for (let i = 0; i < allUnderwritingQuestionsAsFetchedFromDB.length; i++) {
    //   const currentUnderwritingQuestion = SharedConfig.selectedAssetUnderwritingQuestions.find(
    //     (x) => x.underwriting_answers[0].object_field === allUnderwritingQuestionsAsFetchedFromDB[i].underwriting_answers[0].object_field
    //   );
    //   if (currentUnderwritingQuestion) {
    //     allUnderwritingQuestionsAsFetchedFromDB[i] = currentUnderwritingQuestion;
    //   }
    // }

    // SharedConfig.selectedAssetUnderwritingQuestions = allUnderwritingQuestionsAsFetchedFromDB;
  }

  async saveAddress(address: IAddresses): Promise<IAddresses> {
    if (address.id) {
      return this.updateAddress(address);
    } else {
      return this.setAddress(address);
    }
  }

  // async saveAddress(address: IAddresses): Promise<IAddresses> {
  //   if (address.id) {
  //     return this.updateAddress(address);
  //   } else {
  //     return this.setAddress(address);
  //   }
  // }

  async setAddress(address: IAddresses): Promise<IAddresses> {
    return (await firstValueFrom(this.apiQuestionService.setAddress(address))).results;
  }

  async getProgressCheckerQuestions(asset_type: AssetType, asset_id: number): Promise<IProgressChecker> {
    return (await firstValueFrom(this.apiQuestionService.getProgressCheckerQuestions(asset_type, asset_id))).results;
  }

  async searchApi(endpoint: string, search_value: string, additional_params): Promise<any> {
    return (await firstValueFrom(this.apiQuestionService.searchApi(endpoint, search_value, additional_params))).results;
  }


  private async updateAddress(address: IAddresses): Promise<IAddresses> {
    return (await firstValueFrom(this.apiQuestionService.updateAddress(address))).results;
  }

  async vehicleTypes(): Promise<Array<IVheicleType>> {
    return (await firstValueFrom(this.apiQuestionService.getVehiclesTypes())).results
  }

  async getVehicleMake(vehicle_code: string, vehicle_type: AssetType, year_of_manufacture: string): Promise<Array<string>> {
    switch (vehicle_type) {
      case AssetType.Vehicles:
        // TODO BACKEND SHOULD UPDATE THIS
        // return (await firstValueFrom(this.apiQuestionService.getCarMake())).results;
        const motorVehicleMakes = (await firstValueFrom(this.apiQuestionService.getCarMake( vehicle_code, year_of_manufacture))).results;
        return motorVehicleMakes;

      case AssetType.Motorcycles:
        const motorCycleMakes = (await firstValueFrom(this.apiQuestionService.getMotorcycleMake())).results['motorVehicleMakes'];
        return motorCycleMakes;
      default:
        return [];
    }
  }

  async getVehicleModel(vehicle_code: string, vehicle_type: AssetType, code: string, year: string): Promise<Array<any>> {
    switch (vehicle_type) {
      case AssetType.Vehicles:
        const motorVehicleModels = (await firstValueFrom(this.apiQuestionService.getCarModel(vehicle_code, code, year))).results;
        return motorVehicleModels;

      case AssetType.Motorcycles:
        const motorCycleModels = (await firstValueFrom(this.apiQuestionService.getMotorcycleModel(code, year))).results['motorVehicleModels'];
        return motorCycleModels;

      default:
        return [];
    }
  }

  async getVehicleModelVariant(vehicle_type: AssetType, make: string, year: string, model: string): Promise<any> {
    switch (vehicle_type) {
      case AssetType.Vehicles:
        const motorVehicleVariants = (await firstValueFrom(this.apiQuestionService.getCarModelVariant(make, year, model))).results['motorVehicles'];
        return motorVehicleVariants;

      case AssetType.Motorcycles:
        const motorCycleVariants = (await firstValueFrom(this.apiQuestionService.getMotorcycleModelVariant(make, year, model))).results['motorVehicles'];
        return motorCycleVariants;

      default:
        return [];
    }
  }

  async getAddressFromString(address: string): Promise<IPostalCodeAreas> {
    return (await firstValueFrom(this.apiQuestionService.getAddressFromString(address))).results;
  }

  async searchCityWithPostal(postalCode: string): Promise<IPostalCodeAreas> {
    return (await firstValueFrom(this.apiQuestionService.getPostalCodeAreas(postalCode))).results;
  }
  async searchOccupation(searchText: string): Promise<IOccupations> {
    return (await firstValueFrom(this.apiMetaService.searchOccupation(searchText))).results;
  }

  getPersonCheckParentIndex(key): number {
    const index: number = SharedConfig.selectedAssetUnderwritingQuestions.findIndex(
      (x) => x.person_checker && x.person_checker.key === key && x.person_checker.type === 'Parent'
    );
    return index;
  }

  async autoPopulatePersonCheckerQuestions(question: IQuestion): Promise<UnderwritingAnswer[]> {
    const fields: Array<string> = question.person_checker?.source?.split('.') ?? [];
    if (fields.length === 2) {
      if (this.sharedConfig.user[fields[0]] && this.sharedConfig.user[fields[0]][fields[1]] !== undefined) {
        const parentQuestionIndex = this.getPersonCheckParentIndex(question.person_checker.key);
        if (parentQuestionIndex > -1) {
          if (
            SharedConfig.selectedAssetUnderwritingQuestions[parentQuestionIndex].underwriting_answers[0].object_answer ===
            SharedConfig.selectedAssetUnderwritingQuestions[parentQuestionIndex].person_checker.triggerWording
          ) {
            question.underwriting_answers[0].object_answer = this.sharedConfig.user[fields[0]][fields[1]];
          } else {
            delete question.underwriting_answers[0].object_answer;
          }
        }
      }
    }
    return question.underwriting_answers;
  }

  public async getPersonalOrAssetSpecificQuestions(
    user: IUser,
    underwritingQuestionsAll: Array<IQuestion>,
    asset_type: AssetType,
    questionFilteringType = QuestionFilteringType.getHiddenQuestionsForQuestionPage,
    clearAllUnderwritingAnswers = true,
    filterByHeading = null,
    asset_id?: number
  ): Promise<Array<IQuestion>>{
    let filteredAssetSpecificQuestions = [];
    if (asset_type === AssetType.UserPersonalDetails || asset_type === AssetType.UserInsuranceHistory) {
      // const personalDetailsQuestion = (await this.getProgressCheckerQuestions(AssetType.UserPersonalDetails, user.personal_details_id)).questions;
      // const previousInsurerQuestion = (await this.getProgressCheckerQuestions(AssetType.UserInsuranceHistory, user.insurance_history_id)).questions;
      const personalDetailsQuestion = await this.getAssetSpecificQuestions(
        user,
        underwritingQuestionsAll,
        AssetType.UserPersonalDetails,
        this.sharedConfig.getSelectedAsset(AssetType.UserPersonalDetails),
        questionFilteringType,
        clearAllUnderwritingAnswers,
        user.personal_details_id
      );
      const previousInsurerQuestion = await this.getAssetSpecificQuestions(
        user,
        underwritingQuestionsAll,
        AssetType.UserInsuranceHistory,
        this.sharedConfig.getSelectedAsset(AssetType.UserInsuranceHistory),
        questionFilteringType,
        clearAllUnderwritingAnswers,
        user.insurance_history_id
      );
      filteredAssetSpecificQuestions.push(...personalDetailsQuestion, ...previousInsurerQuestion);
    } else {
      // filteredAssetSpecificQuestions = (await this.getProgressCheckerQuestions(asset_type, asset_id)).questions;
      filteredAssetSpecificQuestions = await this.getAssetSpecificQuestions(
        user,
        underwritingQuestionsAll,
        asset_type,
        this.sharedConfig.getSelectedAsset(asset_type),
        questionFilteringType,
        clearAllUnderwritingAnswers,
        asset_id
      );
    }
    if (filterByHeading) {
      return filteredAssetSpecificQuestions.filter((x) => x.heading === filterByHeading);
    } else {
      return filteredAssetSpecificQuestions;
    }
  }

  private async getAssetSpecificQuestions(
    user: IUser,
    underwritingQuestionsAll: IQuestion[],
    asset_type: AssetType,
    selectedAsset: any,
    questionFilteringType: QuestionFilteringType = QuestionFilteringType.getHiddenQuestionsForQuestionPage,
    clearAllUnderwritingAnswers = true,
    asset_id?: number
  ): Promise<IQuestion[]> {
    let questions: IQuestion[] = [];
    const asset_specific_questions = (await this.getProgressCheckerQuestions(asset_type, asset_id)).questions;
    questions = asset_specific_questions.filter((q) => q.underwriting_answers[0].object_name === asset_type);
    const apiNulledFields = new Set(
      questions.flatMap(q => q.underwriting_answers).filter(a => a.object_answer === null).map(a => a.object_field)
    );
    if (clearAllUnderwritingAnswers) questions.forEach((a) => a.underwriting_answers.forEach((x) => delete x.object_answer));

    const filteredQuestions: IQuestion[] = [];
    if (!selectedAsset) selectedAsset = [];
    for (const question of questions) {
      let addToFilteredQuestions = true;

      if (question.dependency && question.dependency.dependency_type === 'Child') {
        const parentDependencyQuestion = questions.find(
          (x) => x.dependency && x.dependency.dependency_key === question.dependency.dependency_key && x.dependency.dependency_type === 'Parent'
        );
        if (parentDependencyQuestion) {
          for (const underwritingAnswer of parentDependencyQuestion.underwriting_answers) {
            if (underwritingAnswer.object_answer !== undefined && underwritingAnswer.object_answer !== null) {
              addToFilteredQuestions = question.dependency.display_when_parent_value_equals === underwritingAnswer.object_answer;
            }
          }
        }
      }

      let bulkUpdatePersonalDetails = false;
      let bulkUpdateInsuranceHistory = false;
      let bulkCreateInsuranceHistory = false;
      for (const underwritingAnswer of question.underwriting_answers) {
        if (underwritingAnswer.hidden && underwritingAnswer.answer !== undefined) {
          // When to override Hidden fields
          // 1. when the field is required AND empty / undefined
          // 2. when the field is required AND answers_old has values AND the field has a value that is inside the type "oldQuestions"

          // override current QuoteRequest answer with existing asset answer if
          // 1.field is required AND answers_old has values AND the field has a value that is NOT inside the type "oldQuestions"
          if (
            (underwritingAnswer.required &&
              (!selectedAsset.hasOwnProperty(underwritingAnswer.object_field) || selectedAsset[underwritingAnswer.object_field] === undefined)) ||
            (underwritingAnswer.required &&
              underwritingAnswer.answers_old &&
              underwritingAnswer.answers_old.includes(selectedAsset[underwritingAnswer.object_field]))
          ) {
            underwritingAnswer.object_answer = underwritingAnswer.answer;
            // update the changed underwriting answer if it has changed or is empty
            if (underwritingAnswer.object_name === AssetType.UserPersonalDetails) {
              bulkUpdatePersonalDetails = true;
              user.personal_details[underwritingAnswer.object_field] = underwritingAnswer.object_answer;
            } else if (underwritingAnswer.object_name === AssetType.UserInsuranceHistory) {
              if (!user.insurance_history) {
                user.insurance_history = {};
              }
              user.insurance_history[underwritingAnswer.object_field] = underwritingAnswer.object_answer;

              if (!user.insurance_history.id) {
                bulkCreateInsuranceHistory = true;
              } else {
                bulkUpdateInsuranceHistory = true;
              }
            } else {
              selectedAsset[underwritingAnswer.object_field] = underwritingAnswer.answer;
            }
          } else if (
            underwritingAnswer.required &&
            underwritingAnswer.answers_old &&
            !underwritingAnswer.answers_old.includes(selectedAsset[underwritingAnswer.object_field])
          ) {
            underwritingAnswer.object_answer = selectedAsset[underwritingAnswer.object_field];
          } else {
            underwritingAnswer.object_answer = underwritingAnswer.answer;
          }

          addToFilteredQuestions = questionFilteringType === QuestionFilteringType.getHiddenQuestionsForQuestionPage ? true : false;
        } else if (!apiNulledFields.has(underwritingAnswer.object_field)) {
          if (underwritingAnswer.object_name === AssetType.UserPersonalDetails && underwritingAnswer.object_field === 'address_id') {
            underwritingAnswer.object_answer = user.personal_details.address_id;
          } else if (selectedAsset.hasOwnProperty(underwritingAnswer.object_field)) {
            underwritingAnswer.object_answer = selectedAsset[underwritingAnswer.object_field];
          }
        }
      }

      if (bulkCreateInsuranceHistory) {
        this.apiUserService.createUserInsuranceHistory(user.insurance_history).pipe(take(1)).subscribe();
      } else if (bulkUpdateInsuranceHistory) {
        this.apiUserService.updateUserInsuranceHistory(user.insurance_history).pipe(take(1)).subscribe();
      }
      if (bulkUpdatePersonalDetails) {
        this.apiUserService.updatePersonalDetails(user.personal_details).pipe(take(1)).subscribe();
      }

      if (addToFilteredQuestions) filteredQuestions.push(question);
    }
    return filteredQuestions;
  }

  allRequiredUnderWritingAnswersPresent(question: IQuestion, quoteRequestSelectedAsset: any, asset_type: AssetType, user: IUser) {
    if (question.underwriting_answers[0].object_field.toLowerCase().includes('address')) {
      // includes risk_address of overnight_address

      let addressId: number;
      if (asset_type === AssetType.UserPersonalDetails) {
        addressId = user.personal_details.address_id;
      } else {
        if (question.underwriting_answers[0].object_field.toLowerCase().includes('daytime')) {
          addressId = quoteRequestSelectedAsset.daytime_address_id;
        } else if (question.underwriting_answers[0].object_field.toLowerCase().includes('overnight')) {
          addressId = quoteRequestSelectedAsset.overnight_address_id;
        } else {
          addressId = quoteRequestSelectedAsset.address_id;
        }
      }

      const isAddressMissing = this.isAddressMissing(addressId);

      if (isAddressMissing) {
        for (const underwritingAnswer of question.underwriting_answers) {
          delete underwritingAnswer.object_answer;
        }
        return false;
      } else {
        return true;
      }
    } else {
      const missing = question.underwriting_answers.some(
        (answer) =>
          ((answer.object_answer === undefined || answer.object_answer === null) && answer.required) ||
          ((answer.object_answer === undefined || answer.object_answer === null) && answer.object_field === 'claims') ||
          ((answer.object_answer === undefined || answer.object_answer === null) && this.isParentTrueThusValidateChild(question))
      );
      return !missing;
    }
  }

  isAddressMissing(addressId: number): boolean {
    return addressId === null || addressId === undefined;
  }

  isPartialAddressMissing(genericField: string, quoteRequestSelectedAsset: any): boolean {
    const addressIdField = `${genericField}_id`;
    const addressId = quoteRequestSelectedAsset[addressIdField];

    if (addressId === null || addressId === undefined) {
      delete quoteRequestSelectedAsset[addressIdField];
      return true;
    } else {
      return false;
    }
  }

  isParentTrueThusValidateChild(question: IQuestion): boolean {
    if (!question.dependency) {
      return false;
    }
    const parentDependencyQuestions = SharedConfig.underwritingQuestionsAll.filter(
      (x) => x.dependency && x.dependency.dependency_key === question.dependency.dependency_key && x.dependency.dependency_type === 'Parent'
    );

    if (parentDependencyQuestions) {
      return true;
    } else {
      return false;
    }
  }

  async isAssetQuestionsComplete(asset_type: AssetType, quoteRequestSelectedAsset: any, user: IUser, asset_id: number): Promise<boolean> {
    const filteredAssetQuestions = await this.getAssetSpecificQuestions(
      user,
      JSON.parse(JSON.stringify(SharedConfig.underwritingQuestionsAll)),
      asset_type,
      quoteRequestSelectedAsset,
      QuestionFilteringType.hideHiddenQuestionsForSummary,
      false,
      asset_id
    );

    const hasUnansweredQuestions = filteredAssetQuestions.some((question) => {
      const answersPresent = this.allRequiredUnderWritingAnswersPresent(question, quoteRequestSelectedAsset, asset_type, user);
      const isValidated = this.busnQuoteScheduleService.isFieldValidationSuccess(
        question.underwriting_answers,
        question,
        quoteRequestSelectedAsset,
        null
      );

      return !answersPresent || !isValidated;
    });

    return !hasUnansweredQuestions;
  }

  async setIsCompleteFlagOnAllAssetsIfCompleted(user: IUser, quoteRequest: IQuoteRequest) {
    if (this.setIsCompleteFlagRunning) return this.setIsCompleteFlagRunning;

    const run = async () => {
      const [isUserPersonalDetails, isUserInsuranceHistory] = await Promise.all([
        this.getProgressCheckerQuestions(AssetType.UserPersonalDetails, user.personal_details_id).then(r => r.progress.progress === 1),
        this.getProgressCheckerQuestions(AssetType.UserInsuranceHistory, user.insurance_history_id).then(r => r.progress.progress === 1),
      ]);
      this.sharedConfig.user.personal_details.is_completed = isUserPersonalDetails;
      this.sharedConfig.user.insurance_history.is_completed = isUserInsuranceHistory;

      await Promise.all([
        ...( quoteRequest.assets?.all_risks?.map(async (all_risks) => {
          const index = quoteRequest.assets.all_risks.findIndex((x) => x.id === all_risks.id);
          const isCompletedPreCheck = quoteRequest.assets.all_risks[index].is_completed;
          const isCompleted = (await this.getProgressCheckerQuestions(AssetType.AllRisks, all_risks.id)).progress.progress === 1;
          quoteRequest.assets.all_risks[index].is_completed = isCompleted;
          if (isCompletedPreCheck !== isCompleted) this.apiAssetService.updateAllRiskItem(all_risks);
        }) ?? []),
        ...( quoteRequest.assets?.buildings?.map(async (building) => {
          const index = quoteRequest.assets.buildings.findIndex((x) => x.id === building.id);
          const isCompletedPreCheck = quoteRequest.assets.buildings[index].is_completed;
          const isCompleted = (await this.getProgressCheckerQuestions(AssetType.Buildings, building.id)).progress.progress === 1;
          quoteRequest.assets.buildings[index].is_completed = isCompleted;
          if (isCompletedPreCheck !== isCompleted) this.apiAssetService.updateBuilding(building);
        }) ?? []),
        ...( quoteRequest.assets?.caravans?.map(async (caravan) => {
          const index = quoteRequest.assets.caravans.findIndex((x) => x.id === caravan.id);
          const isCompletedPreCheck = quoteRequest.assets.caravans[index].is_completed;
          const isCompleted = (await this.getProgressCheckerQuestions(AssetType.Caravans, caravan.id)).progress.progress === 1;
          quoteRequest.assets.caravans[index].is_completed = isCompleted;
          if (isCompletedPreCheck !== isCompleted) this.apiAssetService.updateCaravan(caravan);
        }) ?? []),
        ...( quoteRequest.assets?.contents?.map(async (content) => {
          const index = quoteRequest.assets.contents.findIndex((x) => x.id === content.id);
          const isCompletedPreCheck = quoteRequest.assets.contents[index].is_completed;
          const isCompleted = (await this.getProgressCheckerQuestions(AssetType.Contents, content.id)).progress.progress === 1;
          quoteRequest.assets.contents[index].is_completed = isCompleted;
          if (isCompletedPreCheck !== isCompleted) this.apiAssetService.updateContent(content);
        }) ?? []),
        ...( quoteRequest.assets?.motorcycles?.map(async (motorcycle) => {
          const index = quoteRequest.assets.motorcycles.findIndex((x) => x.id === motorcycle.id);
          const isCompletedPreCheck = quoteRequest.assets.motorcycles[index].is_completed;
          const isCompleted = (await this.getProgressCheckerQuestions(AssetType.Motorcycles, motorcycle.id)).progress.progress === 1;
          quoteRequest.assets.motorcycles[index].is_completed = isCompleted;
          if (isCompletedPreCheck !== isCompleted) this.apiAssetService.updateMotorcycle(motorcycle);
        }) ?? []),
        ...( quoteRequest.assets?.specified_items?.map(async (specified_item) => {
          const index = quoteRequest.assets.specified_items.findIndex((x) => x.id === specified_item.id);
          const isCompletedPreCheck = quoteRequest.assets.specified_items[index].is_completed;
          const isCompleted = (await this.getProgressCheckerQuestions(AssetType.SpecifiedItems, specified_item.id)).progress.progress === 1;
          quoteRequest.assets.specified_items[index].is_completed = isCompleted;
          if (isCompletedPreCheck !== isCompleted) this.apiAssetService.updateSpecifiedItem(specified_item);
        }) ?? []),
        ...( quoteRequest.assets?.vehicles?.map(async (vehicle) => {
          const index = quoteRequest.assets.vehicles.findIndex((x) => x.id === vehicle.id);
          const isCompletedPreCheck = quoteRequest.assets.vehicles[index].is_completed;
          const isCompleted = (await this.getProgressCheckerQuestions(AssetType.Vehicles, vehicle.id)).progress.progress === 1;
          quoteRequest.assets.vehicles[index].is_completed = isCompleted;
          if (isCompletedPreCheck !== isCompleted) this.apiAssetService.updateVehicle(vehicle);
        }) ?? []),
      ]);
    };

    this.setIsCompleteFlagRunning = run().finally(() => { this.setIsCompleteFlagRunning = null; });
    return this.setIsCompleteFlagRunning;
  }

  // checkIfQuoteRequestCompletedAndCanGoNext() {
  //   const assetTypes = ['all_risks', 'buildings', 'caravans', 'contents', 'motorcycles', 'specified_items', 'vehicles'];
  //   const assetsComplete = assetTypes.every(
  //     (type) => !this.sharedConfig.quoteRequest?.assets?.[type]?.some((asset: { is_completed: any }) => !asset.is_completed)
  //   );
  //   //  const totalQuotesCount = assetTypes.reduce((total, type) => total + (quoteRequest?.assets?.[type]?.length || 0), 0);
  //   // const isPersonalDetailsComplete = user.personal_details.is_completed;

  //   //  if (quoteRequest?.type === 'QUOTE') {
  //   // this.liveVariables.isQuoteRequestCompletedAndCanGoNext = isPersonalDetailsComplete && assetsComplete && totalQuotesCount > 0;
  //   this.sharedConfigService.liveVariables.isQuoteRequestCompletedAndCanGoNext = assetsComplete;
  //   //   } else {
  //   //   this.liveVariables.isQuoteRequestCompletedAndCanGoNext = assetsComplete && totalQuotesCount > 0;
  //   //   this.liveVariables.isQuoteRequestCompletedAndCanGoNext = assetsComplete;
  //   // }
  // }

  initializeIndividualQuestionLoaders(
    asset_type: AssetType,
    from_page: fromPage,
    selectedAssetUnderwritingQuestions: IQuestion[],
    quote_type?: QuoteType
  ) {
    const questionGroup = [];
    const totalQuestions = 100 / selectedAssetUnderwritingQuestions.length;
    const uniqueHeadings = this.getUniqueUnderwritingQuestionHeadings(from_page, selectedAssetUnderwritingQuestions, quote_type);
    // Questions at/after the first one that fails validation haven't been reached yet in the flow,
    // even if their object_answer already holds a stray/default value (e.g. an empty array) - don't count those as answered.
    const firstUnansweredIndex = selectedAssetUnderwritingQuestions.findIndex(
      (x) => !this.busnQuoteScheduleService.isFieldValidationSuccess(x.underwriting_answers, x, this.sharedConfig.getSelectedAsset(asset_type))
    );
    const reachedQuestions = selectedAssetUnderwritingQuestions.slice(
      0,
      firstUnansweredIndex === -1 ? selectedAssetUnderwritingQuestions.length : firstUnansweredIndex
    );
    for (let groupIndex = 0; groupIndex < uniqueHeadings.length; groupIndex++) {
      const heading = uniqueHeadings[groupIndex];
      const allQuestionsWithHeading = selectedAssetUnderwritingQuestions.filter(
        (x) => x.heading === heading
      );
      // This will compile as needed and return your desired structure
      switch (from_page) {
        case 'question_comp':
          const totalAnswered = reachedQuestions.filter((x) => x.heading === heading).length;

          questionGroup.push({
            index: groupIndex,
            size: allQuestionsWithHeading.length,
            width_of_progress_bar: allQuestionsWithHeading.length * totalQuestions,
            total_answered: totalAnswered,
          });
          break;
        case 'quote_claims_history_check':
          questionGroup.push({
            index: groupIndex,
            answeredQuestions: allQuestionsWithHeading,
            headings: heading,
            total_answered: 0,
          });
          break;
        case 'quote_summary_not_editable':
          questionGroup.push({
            index: groupIndex,
            answeredQuestions: allQuestionsWithHeading,
            headings: heading,
            total_answered: 0,
          });
          break;
        default:
          break;
      }
    }
    return questionGroup;
  }

  getUniqueUnderwritingQuestionHeadings(from_page: fromPage, selectedAssetUnderwritingQuestions, quote_type?): string[] {
    const headings = [];
    if (from_page === 'question_comp' || from_page === 'quote_summary_not_editable') {
      if (quote_type === QuoteType.MyProfile) {
        for (const selectedAssetUWQ of selectedAssetUnderwritingQuestions.filter(
          (x) =>  x.underwriting_answers[0].object_name === AssetType.UserPersonalDetails
        )) {
          headings.push(selectedAssetUWQ.heading);
        }
      } else {
        for (const selectedAssetUWQ of selectedAssetUnderwritingQuestions) {
          headings.push(selectedAssetUWQ.heading);
        }
      }
    } else {
      for (const selectedAssetUWQ of selectedAssetUnderwritingQuestions.filter(
        (x) => x.underwriting_answers[0].object_name === AssetType.UserInsuranceHistory
      )) {
        headings.push(selectedAssetUWQ.heading);
      }
    }

    return headings.filter((heading, index) => headings.indexOf(heading) === index);
  }
}
